<template>
  <div class="content-container">
    <panel
      class="content"
      title=""
      v-cloak
    >
      <template v-slot:body>
        <span>{{ __('Sikeres regisztráció.') }}</span>
      </template>
    </panel>
  </div>
</template>

<script>
import { Panel } from "@teamfurther/cinderblock";

export default {
  components: {
    Panel
  }
}
</script>

<style scoped lang="scss">
.content-container {
  margin-top: 100px;
}
</style>
